import { Modal, Space, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { orange } from '@ant-design/colors'

export type Props = {
  visible: boolean
  onCancel: () => void
  onSave: () => void
  loading?: boolean
}

const RegenerateRoutesModal = ({ visible, onCancel, onSave, loading = false }: Props) => {
  return (
    <Modal
      open={visible}
      title={
        <Space>
          <FontAwesomeIcon icon={faExclamationCircle} color={orange.primary} />
          <span>Regenerate Routes?</span>
        </Space>
      }
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={onSave} loading={loading}>
          Save
        </Button>
      ]}
      closable={true}
      maskClosable={false}
      width={500}
    >
      <p>
        Are you sure you want to apply these changes? <strong>Your future events will be regenerated</strong> based on the updated schedule.
      </p>
    </Modal>
  )
}

export default RegenerateRoutesModal
